export const envConstants = {
  ENV_DEVELOPPEMENT: 'development',
};
